/** @typedef {import('headlight-configurable-application').Pict} Pict */
// @ts-ignore
const PictProvider = require('pict-provider');

class ProjectFileProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('pict')} */
		this.pict;
		/** @type {import('pict') & { newAnticipate: () => any }} */
		this.fable;
		/** @type {any} */
		this.log;
	}

	/**
	 * Get the parent folder IDs for a given folder
	 * @param {Object} folder - The folder object to get the parent IDs for
	 * @param {Object} currentDataStructureList - The current data structure list to check against
	 * @param {Array} parentFolderIDs - The array of parent folder IDs to populate
	 * @return {Array} - An array of parent folder IDs
	 */
	getParentFolderIDs(folder, currentDataStructureList, parentFolderIDs = [])
	{
		if (folder.ParentIDProjectFileFolder === 0)
		{
			return parentFolderIDs;
		}
		if (folder.ParentIDProjectFileFolder > 0 && !currentDataStructureList.ProjectFileFolders.find( (x) => x.IDProjectFileFolder === folder.ParentIDProjectFileFolder))
		{
			//console.log('[DEBUG] getParentIDs', folder.ParentIDProjectFileFolder, parentFolderIDs, currentFolderList);
			parentFolderIDs.push(folder.ParentIDProjectFileFolder);

			const parentFolder = currentDataStructureList.AllProjectFileFolders.find((x) => x.IDProjectFileFolder === folder.ParentIDProjectFileFolder);
			if (Object.keys(parentFolder).length !== 0)
			{
				//add folder to existing list of ProjectFileFolders
				currentDataStructureList.ProjectFileFolders.push(parentFolder);
				return this.getParentFolderIDs(parentFolder, currentDataStructureList, parentFolderIDs);
			}
			else
			{
				this.log.error(`Parent folder with ID ${folder.ParentIDProjectFileFolder} not found for folder ${folder.Name}`);
				return parentFolderIDs;
			}
		}
	}

	getProjectFolderMapKey(pIDProjectFolder)
	{
		return `ProjectFolderMap~${pIDProjectFolder}`;
	}

	/**
	 * @param {string} rawString with special characters to escape
	 * @description Escapes special characters in a string to be used in a regular expression.
	 * @return {string} - The escaped string.
	 */
	escapeRegExp(rawString)
	{
		return rawString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	/**
	 * Get the project files and return in a structured format
	 * @param {Number} pIDProject - ID of the project being searched in
	 * @param {Object} pSearchFilters - Object containing the search filters, e.g. SearchText for files and SearchFolder for folders
	 * @param {Function} fCallback
	 */
	getProjectFilesDataStructure(pIDProject, pSearchFilters, fCallback)
	{
		this.pict.log.info(`I am getting project files for project ${pIDProject}`);

		let fileMeadowQuery = `FBV~IDProject~EQ~${pIDProject}`;

		const folderMeadowQuery = `FBV~IDProject~EQ~${pIDProject}`;
		const hasFolderSearchFilters = pSearchFilters?.SearchFolder && pSearchFilters?.SearchFolder.trim().length > 0;
		if (pSearchFilters?.SearchText && pSearchFilters?.SearchText.trim().length > 0)
		{
			fileMeadowQuery = `FBV~IDProject~EQ~${pIDProject}~FBV~Name~LK~%25${encodeURIComponent(pSearchFilters.SearchText.replace(/\*/g, '%25'))}%25`;
		}

		// @ts-ignore
		const tmpAnticipate = this.pict.newAnticipate();

		const tmpProjectFileDataStructureState = {};

		tmpAnticipate.anticipate(
			function(fNext)
			{
				// Expire the cache for ProjectFile
				this.pict.EntityProvider?.recordSetCache?.['ProjectFile']?.expire(`FBV~IDProject~EQ~${pIDProject}`);
				this.pict.EntityProvider.getEntitySet('ProjectFile', fileMeadowQuery,
					function(pError, pRecordSet)
					{
						if (pError)
						{
							this.log.error(`Error downloading project files for project ${pIDProject}: ${pError}`, pError);
							return fCallback(pError);
						}

						// for (let i = 0; i < pRecordSet.length; i++)
						// {
						// 	this.pict.log.info(`I found project file number ${i} for project ${pIDProject}: ${JSON.stringify(pRecordSet[i])}`);
						// }

						tmpProjectFileDataStructureState.ProjectFiles = pRecordSet;

						return fNext();
					}.bind(this));
			}.bind(this));


		tmpAnticipate.anticipate(
			function(fNext)
			{
				// Expire the cache for ProjectFileFolder
				this.pict.EntityProvider?.recordSetCache?.['ProjectFileFolder']?.expire(`FBV~IDProject~EQ~${pIDProject}`);
				//folderMeadowQuery is set to Project ID and then filtered later to match the Name
				this.pict.EntityProvider.getEntitySet('ProjectFileFolder', folderMeadowQuery,
					function(pError, pRecordSet)
					{
						if (pError)
						{
							this.log.error(`Error downloading project file folders for project ${pIDProject}: ${pError}`, pError);
							return fCallback(pError);
						}

						// for (let i = 0; i < pRecordSet.length; i++)
						// {
						// 	this.pict.log.info(`I found project file folder number ${i} for project ${pIDProject}: ${JSON.stringify(pRecordSet[i])}`);
						// }

						tmpProjectFileDataStructureState.AllProjectFileFolders = pRecordSet;
						if (!hasFolderSearchFilters)
						{
							// if there are no search filters, just return all folders
							tmpProjectFileDataStructureState.ProjectFileFolders = pRecordSet;
							return fNext();
						}
						const regex = new RegExp(this.escapeRegExp(pSearchFilters.SearchFolder), 'i'); // 'i' flag for case-insensitive matching
						tmpProjectFileDataStructureState.ProjectFileFolders = pRecordSet.filter((folder) => regex.test(folder.Name));
						return fNext();
					}.bind(this));
			}.bind(this));

		//retrieve parent folders and add to the data structure
		tmpAnticipate.anticipate(
			function(fNext)
			{
				if (hasFolderSearchFilters)
				{
					const tmpParentFolderIDs = [];
					for (let i = 0; i < tmpProjectFileDataStructureState.ProjectFileFolders.length; i++)
					{
						const tmpFolder = tmpProjectFileDataStructureState.ProjectFileFolders[i];
						// if the folder has a parent and Not in ProjectFolderMap, add to list
						if (tmpFolder.ParentIDProjectFileFolder > 0 && !tmpParentFolderIDs.includes(tmpFolder.ParentIDProjectFileFolder))
						{
							tmpParentFolderIDs.push(this.getParentFolderIDs(tmpFolder, tmpProjectFileDataStructureState, tmpParentFolderIDs));
						}
					}

					if (tmpParentFolderIDs.length > 0)
					{
						//sort the project files as the above array is not built in any order
						tmpProjectFileDataStructureState.ProjectFileFolders.sort((a, b) =>
						{
							return a.IDProjectFileFolder - b.IDProjectFileFolder;
						});
						return fNext();
					}
					else
					{
						// No missing parent folders
						return fNext();
					}
				}
				else
				{
					// No missing parent folders
					return fNext();
				}
			}.bind(this));

		/*
		* This is where we take both project files and folders and merge them
		* into the same data structure to make them simpler to deal with on
		* the UI.
		*
		* The data structure will be an array of objects.
		* Each object will have the following properties:
		* - Name - the file name
		* - Type - the type of the object (Folder or any of the the file types appropriate to the Headlight Program)
		* - Size - the size of the object (in bytes -- would be awesome to show how large folders are but we can make that advanced thing later)
		* - Date - the date of the object
		* - Entity - A simple string reference to which entity this came from (ProjectFile or ProjectFileFolder)
		* - ID - the ID of the Entity
		*
		* Example Objects:
		* {
		* 	Name: 'MyFile.txt',
		* 	Type: 'File',
		* 	Size: 1234,
		* 	Date: '2014-01-01 12:00:00',
		* 	Entity: 'ProjectFile',
		* 	ID: 1234
		* }
		*
		* {
		* 	Name: 'MyFolder',
		* 	Type: 'Folder',
		* 	Size: 0,
		* 	Date: '2014-01-01 12:00:00',
		* 	Entity: 'ProjectFileFolder',
		* 	ID: 1234,
		*   ParentFolder: 1233
		* }
		*/
		tmpAnticipate.anticipate(
			function(fNext)
			{
				tmpProjectFileDataStructureState.MergedProjectFiles = [];
				// The folder map is going to potentially have circular references
				// This means the data structure won't be serializable.  Too bad.
				tmpProjectFileDataStructureState.ProjectFolderMap = {};

				// First, enumerate all folders and make map of them
				for (let i = 0; i < tmpProjectFileDataStructureState.ProjectFileFolders.length; i++)
				{
					const tmpFolder = tmpProjectFileDataStructureState.ProjectFileFolders[i];

					tmpProjectFileDataStructureState.ProjectFolderMap[this.getProjectFolderMapKey(tmpFolder.IDProjectFileFolder)] = (
						{
							Name: tmpFolder.Name,
							Type: 'Folder',
							Size: 0,
							Date: tmpFolder.UpdateDate,
							Entity: 'ProjectFileFolder',
							IsFolder: 1,
							IsCustomerFolder: 0,
							ID: tmpFolder.IDProjectFileFolder,
							ParentFolder: tmpFolder.ParentIDProjectFileFolder,
							Children: [],
							_RowID: `${tmpFolder.Name.trim().replace(/ /g, '_').replace(/'/g, '')}_${tmpFolder.IDProjectFileFolder}`,
						});
				}

				// Second, build the tree of the folders
				const tmpProjectFileFolderKeys = Object.keys(tmpProjectFileDataStructureState.ProjectFolderMap);
				for (let i = 0; i < tmpProjectFileFolderKeys.length; i++)
				{
					const tmpFolderKey = tmpProjectFileFolderKeys[i];
					const tmpFolder = tmpProjectFileDataStructureState.ProjectFolderMap[tmpFolderKey];

					// Add the folder to its parent
					if (tmpFolder.ParentFolder > 0)
					{
						const tmpParentFolderKey = this.getProjectFolderMapKey(tmpFolder.ParentFolder);
						if (tmpProjectFileDataStructureState.ProjectFolderMap[tmpParentFolderKey])
						{
							tmpProjectFileDataStructureState.ProjectFolderMap[tmpParentFolderKey].Children.push(tmpFolder);
						}
						else
						{
							this.log.error(`Error adding folder ${tmpFolder.Name} to parent ${tmpParentFolderKey}: Parent not found`);
						}
					}
					else
					{
						// This is a root folder
						tmpProjectFileDataStructureState.MergedProjectFiles.push(tmpFolder);
					}
				}

				// Lastly, add the files to the folder on the tree
				for (let i = 0; i < tmpProjectFileDataStructureState.ProjectFiles.length; i++)
				{
					const tmpFile = tmpProjectFileDataStructureState.ProjectFiles[i];

					const tmpFolderKey = this.getProjectFolderMapKey(tmpFile.IDProjectFileFolder);
					if (tmpProjectFileDataStructureState.ProjectFolderMap[tmpFolderKey])
					{
						tmpProjectFileDataStructureState.ProjectFolderMap[tmpFolderKey].Children.push(
							{
								Name: tmpFile.Name,
								Type: tmpFile.FileType,
								Size: 0,
								Date: tmpFile.UpdateDate,
								Entity: 'ProjectFile',
								IsFolder: 0,
								ID: tmpFile.IDProjectFile,
								IDObservation: tmpFile.IDObservation,
								_RowID: `File-${tmpFile.IDProjectFile}_${tmpFile.IDObservation}`,
							});
					}
					// If the file is not in a folder, create a 'Customer Files' folder and add it there
					else if (tmpFile.IDProjectFileFolder === 0)
					{
						const tmpCustomerFilesFolderKey = this.getProjectFolderMapKey(0);
						if (!tmpProjectFileDataStructureState.ProjectFolderMap[tmpCustomerFilesFolderKey])
						{
							tmpProjectFileDataStructureState.ProjectFolderMap[tmpCustomerFilesFolderKey] = (
								{
									Name: 'Customer Files',
									Type: 'Folder',
									Size: 0,
									Date: tmpFile.UpdateDate,
									Entity: 'ProjectFileFolder',
									IsFolder: 1,
									ID: 0,
									ParentFolder: 0,
									IsCustomerFolder: 1,
									Children: [],
									_RowID: `Customer_Files_0`,
								});
							tmpProjectFileDataStructureState.MergedProjectFiles.push(tmpProjectFileDataStructureState.ProjectFolderMap[tmpCustomerFilesFolderKey]);
						}
						tmpProjectFileDataStructureState.ProjectFolderMap[tmpCustomerFilesFolderKey].Children.push(
							{
								Name: tmpFile.Name,
								Type: tmpFile.FileType,
								Size: 0,
								Date: tmpFile.UpdateDate,
								Entity: 'ProjectFile',
								IsFolder: 0,
								ID: tmpFile.IDProjectFile,
								IDObservation: tmpFile.IDObservation,
								_RowID: `File-${tmpFile.IDProjectFile}_${tmpFile.IDObservation}`,
							});
					}
					// If the folder is not found, log an error
					else
					{
						this.log.error(`Error adding file ${tmpFile.Name} to folder ${tmpFolderKey}: Folder not found`);
					}
				}

				// hide empty folders if we're searching for a file
				if (pSearchFilters?.SearchText && pSearchFilters?.SearchText.trim().length > 0)
				{
					const doesFolderHaveFiles = (arr) =>
					{
						for (let i = 0; i < arr.length; i++)
						{
							const element = arr[i];

							if (element.IsFolder === 0)
							{
								return element;
							}
							else if (element.Children?.length > 0)
							{
								const foundInNested = doesFolderHaveFiles(element.Children);
								if (foundInNested !== undefined)
								{
									return foundInNested;
								}
								else
								{
									delete arr[i];
								}
							}
						}
						return undefined;
					};

					for (let index = 0; index < tmpProjectFileDataStructureState.MergedProjectFiles.length; index++)
					{
						if (!doesFolderHaveFiles(tmpProjectFileDataStructureState.MergedProjectFiles[index].Children))
						{
							delete tmpProjectFileDataStructureState.MergedProjectFiles[index];
						}
					}
				}
				return fNext(tmpProjectFileDataStructureState.MergedProjectFiles);
			}.bind(this));

		tmpAnticipate.wait(fCallback);
	}


	/**
	 * Get the ProjectFile by ID
	 * @param {Number} pIDProjectFile - The ID of the ProjectFile to get
	 * @param {Function} pCallback - The callback function to call when the ProjectFile is fetched
	 * @return {Promise}
	 * @async
	 */
	async getProjectFileByID(pIDProjectFile, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// @ts-ignore
				this.pict.fable.services.HeadlightRestClient.getJSON(`ProjectFile/${pIDProjectFile}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching ProjectFile: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching ProjectFile: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	async getProjectFileByIDList(pIDProjectFileList, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				// @ts-ignore
				this.pict.fable.services.HeadlightRestClient.getJSON(`ProjectFiles/FilteredTo/FBL~IDProjectFile~INN~${pIDProjectFileList.join(',')}`,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching ProjectFiles by id list: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching ProjectFiles by id list: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get the ProjectFolders by ProjectID
	 * @param {Number} pIDProject - The ID of the Project to get
	 * @param {Function} pCallback - The callback function to call when the ProjectFolders are fetched
	 * @return {Promise}
	 * @async
	 */
	async getProjectFileFoldersByProjectID(pIDProject, pCallback)
	{
		try
		{
			return await new Promise((resolve, reject) =>
			{
				const tmpURL = `ProjectFileFolders/By/IDProject/${pIDProject}`;

				// @ts-ignore
				this.pict.fable.services.HeadlightRestClient.getJSON(tmpURL,
					(pError, pBody) =>
					{
						if (pError)
						{
							this.pict.log.error(`Error fetching ProjectFileFolders: `, pError);
							reject(pError);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(null);
							}
						}
						else
						{
							resolve(pBody);
							// if we have a callback, run it now
							if (pCallback)
							{
								pCallback(pBody);
							}
						}
					});
			});
		}
		catch (error)
		{
			this.pict.log.error(`Error fetching ProjectFileFolders: `, error);
			// if we have a callback, run it now
			if (pCallback)
			{
				pCallback(null);
			}
		}
	}

	/**
	 * Get the ProjectFileFolder search count
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getProjectFileFolderSearchCount({ IDProject: 1234, Name: '2014' }, (count) => { console.log(count); });
	 */
	async getProjectFileFolderSearchCount(pSearchQuery, pCallback)
	{
		const tmpFilter = this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const tmpURL = `ProjectFileFolders/Count${tmpFilter ? `/${tmpFilter}` : ''}`;
		// @ts-ignore
		this.pict.HeadlightRestClient.getJSON(tmpURL,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing request for Count: ${pError}`, pError);
				}
				pCallback(pBody?.Count || 0);
			});
	}

	/**
	 * Get the ProjectFileFolder search results
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getProjectFileFolderSearchResults({ IDProject: 1234, Name: '2014' }, (results) => { console.log(results); });
	 */
	async getProjectFileFolderSearchResults(pSearchQuery, pCallback)
	{
		const tmpURL = `ProjectFileFolders/` + this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const startCount = (pSearchQuery.pagination.start - 1) * pSearchQuery.pagination.limit;
		const endCount = pSearchQuery.pagination.start * pSearchQuery.pagination.limit;
		// @ts-ignore
		this.pict.HeadlightRestClient.getJSON(`${tmpURL}/${startCount}/${endCount}`,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
				}
				pCallback(Array.isArray(pBody) ? pBody : []);
			});
	}

	/**
	 * Get the ProjectFile search count
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getProjectFileSearchCount({ IDProject: 1234 }, (count) => { console.log(count); });
	 */
	async getProjectFileSearchCount(pSearchQuery, pCallback)
	{
		const tmpFilter = this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const tmpURL = `ProjectFiles/Count${tmpFilter ? `/${tmpFilter}` : ''}`;
		// @ts-ignore
		this.pict.HeadlightRestClient.getJSON(tmpURL,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing request for Count: ${pError}`, pError);
				}
				pCallback(pBody?.Count || 0);
			});
	}

	/**
	 * Get the ProjectFile search results
	 * @param {Object} pSearchQuery - The search query object to use when performing the search
	 * @param {Function} pCallback - The callback function to call when the search is complete
	 * @async
	 * @example
	 * getProjectFileSearchResults({ IDProject: 1234 }, (results) => { console.log(results); });
	 */
	async getProjectFileSearchResults(pSearchQuery, pCallback)
	{
		const tmpURL = `ProjectFiles/` + this.pict.providers.UtilityProvider.generateMeadowFilter(pSearchQuery);
		const startCount = (pSearchQuery.pagination.start - 1) * pSearchQuery.pagination.limit;
		const endCount = pSearchQuery.pagination.start * pSearchQuery.pagination.limit;
		// @ts-ignore
		this.pict.HeadlightRestClient.getJSON(`${tmpURL}/${startCount}/${endCount}`,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error performing search: ${pError}`, pError);
				}
				pCallback(Array.isArray(pBody) ? pBody : []);
			});
	}

	/**
	 * This method performs an ProjectFile search based on the current search filters.
	 * @param {Object} pOptions - The options to use when performing the search.
	 * @param {Function} pLocalCallback - The callback function to call when the search is complete
	 * @async
	 */
	async performProjectFileSearch(pOptions = {}, pLocalCallback)
	{
		const tmpSearchQuery = {
			filters: [],
			pagination: {
				start: pOptions?.CurrentPage || 1,
				limit: pOptions?.PageSize || 25,
			},
			sort: {
				field: pOptions.SortBy || 'CreateDate',
				direction: pOptions.SortDirection || 'DESC',
			},
		};
		const folderSearchQuery = JSON.parse(JSON.stringify(tmpSearchQuery));

		// handle the search filters
		if (pOptions?.SearchText && pOptions.SearchText?.trim().length > 0)
		{
			tmpSearchQuery.filters.push({
				field: 'Name',
				comparator: 'LK',
				target: pOptions.SearchText,
			});
		}
		if (pOptions?.Projects && pOptions.Projects.length > 0)
		{
			tmpSearchQuery.filters.push({
				field: 'IDProject',
				comparator: pOptions.Projects.length === 1 ? 'EQ' : 'INN',
				target: pOptions.Projects.length === 1 ? pOptions.Projects[0] : pOptions.Projects,
			});

			folderSearchQuery.filters.push({
				field: 'IDProject',
				comparator: pOptions.Projects.length === 1 ? 'EQ' : 'INN',
				target: pOptions.Projects.length === 1 ? pOptions.Projects[0] : pOptions.Projects,
			});
		}
		if (pOptions?.SearchFolder && pOptions.SearchFolder?.trim().length > 0)
		{
			folderSearchQuery.filters.push({
				field: 'Name',
				comparator: 'LK',
				target: pOptions.SearchFolder,
			});
		}

		try
		{
			// @ts-ignore
			this.getProjectFileFolderSearchCount(folderSearchQuery, (pFolderCountResults) =>
			{
				this.getProjectFileFolderSearchResults(folderSearchQuery, (pFolderSearchResults) =>
				{
					if (pFolderSearchResults)
					{
						tmpSearchQuery.filters.push({
							field: 'IDProjectFileFolder',
							comparator: pFolderSearchResults.length === 1 ? 'EQ' : 'INN',
							target: pFolderSearchResults.length === 1 ? pFolderSearchResults[0].IDProjectFileFolder : pFolderSearchResults.map((x) => x.IDProjectFileFolder),
						});
					}

					this.getProjectFileSearchCount(tmpSearchQuery, (pCountResults) =>
					{
						// get the results
						this.getProjectFileSearchResults(tmpSearchQuery, (pSearchResults) =>
						{
							// if there is a local callback function, call it
							if (pLocalCallback)
							{
								// call the local callback with the results of both the count and the search
								pLocalCallback(pSearchResults, pCountResults);
							}
						});
					});
				});
			});
		}
		catch (error)
		{
			this.pict.log.error('Error performing ProjectFile search:', error);
			this.pict.views.HeadlightPanels.toast({
				message: `<strong>Error performing ProjectFile search:</strong><br/><em>${error.message || error}</em>`,
				type: 'is-danger',
			});
			// if there is a local callback function, call it
			if (pLocalCallback)
			{
				pLocalCallback([]);
			}
		}
	}

	/**
	 * Post an update to a Project File to the server.
	 * @param {Object} pProjectFile - The updated ProjectFile to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async updateProjectFile(pProjectFile, fOnSaveResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `ProjectFile/`;
		// @ts-ignore
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.putJSON(tmpURL, pProjectFile,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating file: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the file.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating file: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating file: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the file.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating file: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Add a new Project File to the server.
	 * @param {Object} pProjectFile - The updated ProjectFileFolder to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async addProjectFile(pProjectFile, fOnSaveResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `ProjectFile/`;
		// @ts-ignore
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.postJSON(tmpURL, pProjectFile,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error adding file: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred adding the file.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error adding file: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error adding file: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred adding the file.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error adding file: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Add a new Project Folder to the server.
	 * @param {Object} pProjectFileFolder - The updated ProjectFileFolder to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async addProjectFolder(pProjectFileFolder, fOnSaveResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `ProjectFileFolder/`;
		// @ts-ignore
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.postJSON(tmpURL, pProjectFileFolder,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error adding folder: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred adding the folder.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error adding folder: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error adding folder: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred adding the folder.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error adding folder: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Post an update to a Project Folder to the server.
	 * @param {Object} pProjectFileFolder - The updated ProjectFileFolder to post
	 * @param {Function} fOnSaveResult - The callback function to call when the project file is posted
	 */
	async updateProjectFolder(pProjectFileFolder, fOnSaveResult)
	{
		const uploadID = this.pict.providers.UploadTracking.trackUpload();
		const tmpURL = `ProjectFileFolder/`;
		// @ts-ignore
		await new Promise((resolve, reject) => this.pict.fable.services.HeadlightRestClient.putJSON(tmpURL, pProjectFileFolder,
			(pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error updating folder: `, pError);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the folder.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating folder: ` + pError));
				}
				else if (pBody && pBody.Error)
				{
					this.pict.log.error(`Error updating folder: `, pBody.Error);
					this.pict.views.HeadlightPanels.toast({
						message: 'An error occurred updating the folder.',
						type: 'is-danger',
					});
					this.pict.providers.UtilityProvider.removeAllLoadingClasses();
					reject(new Error(`Error updating folder: ` + pBody.Error));
				}
				else if (pBody)
				{
					resolve(pBody);
					fOnSaveResult(pBody);
				}
				this.pict.providers.UploadTracking.untrackUpload(uploadID);
			},
		));
	}

	/**
	 * Opens the observation panel for the user to select/search/upload images.
	 * @param {number} pIDProjectFile - The view object.
	 * @param {Object} pCallback - The input object.
	 * @return {void}
	 */
	handleProjectFileDeletion(pIDProjectFile, pCallback)
	{
		if (!pIDProjectFile)
		{
			this.pict.log.error('IDProjectFile was not passed.');
			return;
		}
		// @ts-ignore
		this.pict.HeadlightRestClient.deleteEntity('ProjectFile', pIDProjectFile, (pError, pBody) =>
		{
			if (pError)
			{
				this.pict.log.error('Failed to delete project file.', pError);
				this.pict.views.HeadlightPanels.toast({
					message: 'Failed to delete project file!',
					type: 'is-danger',
				});
				pCallback(pError);
			}
			else
			{
			this.pict.log.info('Project File deleted successfully.', pBody);
			if (typeof pCallback === 'function')
			{
				pCallback(pBody);
			}
			}
		});
	}

	/**
	 * Opens the observation search panel for the user to select/search/ observations to add as project files.
	 * @param {Object} pView - The view object.
	 * @param {Object} pInput - The input object.
	 * @param {string} pTarget - The target of the observation addition.
	 * @return {void}
	 */
	openSearchPanel(pView, pInput, pTarget)
	{
		this.pict.views.ObservationCreateMedia.InstanceConfiguration.onAfterDocumentJoinCallback = async (observationResult) =>
		{
			await this.pict.views.ProjectFileSearch.addObservationToProjectFolderRecord(observationResult);
		};
		pView.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', async () =>
		{
			if (pTarget && pTarget === 'add-to-folder')
			{
				// start at the upload tab
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation');
				// set the target for the observation panel to update
				pView.pict.views.HeadlightPaneObservations.setObservationPanelTarget(pView.Hash, pInput, pInput, 'add-to-folder');
				//FIXME: mirgate this to call the new entry point to encapsulate this state
				this.pict.views.ObservationSearch.SearchResultActionLabel = 'Add to Folder';
				this.pict.views.HeadlightPaneObservations.SearchResultActionLabel = 'Add to Folder';
			}
			if (pTarget && pTarget === 'add-to-root')
			{
				// start at the upload tab
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation');
				// set the target for the observation panel to update
				pView.pict.views.HeadlightPaneObservations.setObservationPanelTarget(pView.Hash, pInput, pInput, 'add-to-root');
				//FIXME: mirgate this to call the new entry point to encapsulate this state
				this.pict.views.ObservationSearch.SearchResultActionLabel = 'Add to Project Root';
				this.pict.views.HeadlightPaneObservations.SearchResultActionLabel = 'Add to Project Root';
			}
		});
	}
}

module.exports = ProjectFileProvider;
module.exports.default_configuration = {};
